export default __webpack_public_path__ + "static/media/pic80.b54afdfe.jpg";